'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commentToJson = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _toJS = require('transmute/toJS');

var _toJS2 = _interopRequireDefault(_toJS);

var _pick = require('transmute/pick');

var _pick2 = _interopRequireDefault(_pick);

var _getMappedCommentSenderType = require('./getMappedCommentSenderType');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEYS_TO_SERIALIZE = ['@type', 'text', 'richText', 'sender', 'status', 'userIds', 'attachments', 'id', 'timestamp', 'echo'];

var commentToJson = exports.commentToJson = function commentToJson(message) {
  return (0, _pipe2.default)(_toJS2.default, function (payload) {
    return _extends({}, payload.metadata, {
      sender: {
        '@type': (0, _getMappedCommentSenderType.getMappedSenderTypeForPubnub)(payload.senderType),
        id: payload.senderId
      },
      status: _extends({}, payload.metadata.status, {
        timestamp: payload.timestamp
      }),
      id: payload.id,
      timestamp: payload.timestamp
    });
  }, (0, _pick2.default)(KEYS_TO_SERIALIZE))(message);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/CommentToJson.js
// module id = 769
// module chunks = 2 3